import $ from 'jquery';

export default function bind() {
  $(window).on('beforeunload', function() {
    const $dirtyForms = $('form.dirty');
    if ($dirtyForms.length === 0) {
      return;
    }
    // Prevent multiple prompts - seen on Chrome and IE
    if (navigator.userAgent.toLowerCase().match(/msie|chrome/)) {
      if (window.aysHasPrompted) {
        return;
      }
      window.aysHasPrompted = true;
      window.setTimeout(function() {
        window.aysHasPrompted = false;
      }, 900);
    }

    return 'Modifications non sauvegardées';
  });
}



// WEBPACK FOOTER //
// ./src/plugins/dirtyForm.js